module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-15-APRILE-6f13487dc75241959c288ab46c5e0875.jpg";